// import React from 'react'
// import { Link } from 'react-router-dom'

// const About3 = (props) => {

//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }



//     return (
//         <section className={"" + props.hclass}>
//             <div className="about-wrap">
//                 <div className="image fade_bottom">
//                     <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1765255333/1.94a5b743677d8a961627_vkurgk.jpg`} alt="" />
//                 </div>
//                 <div className="content">
//                     <h2 className='fade_bottom' style={{ fontWeight: "900" }}>About Quality Homes And Builders</h2>
//                     <p className='fade_bottom'> Quality Homes And Builders delivers reliable, high-quality residential construction
//                         with a focus on smart design, durable materials, and timely execution.
//                         From concept to completion, we build homes that reflect trust, craftsmanship,
//                         and modern living.</p>
//                     <div className="about-btn">
//                         <Link
//                             onClick={ClickHandler}
//                             to="/about"
//                             className="theme-btn"
//                             style={{
//                                 backgroundColor: "#FACD2B",
//                                 borderColor: "#FACD2B",
//                                 color: "#000",          // better contrast
//                             }}
//                         >
//                             <span className="rolling-text">
//                                 Discover More
//                             </span>
//                         </Link>
//                     </div>
//                 </div>
//                 <div className="image fade_bottom">
//                     <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1765255332/2.ce8b099b5b193f2465bc_ie5go5.jpg`} alt="" />
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default About3;

import React from 'react'
import { Link } from 'react-router-dom'

const About3 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={props.hclass}>
            <div className="about-wrap">

                <div className="image fade_bottom">
                    <img
                        src="https://res.cloudinary.com/dexvxngzg/image/upload/v1765255333/1.94a5b743677d8a961627_vkurgk.jpg"
                        alt=""
                    />
                </div>

                <div className="content">
                    {/* ✅ FINAL HEADING (Exact Case as Requested) */}
                    <h2
                        className="fade_bottom"
                        style={{
                            fontWeight: 900,
                            fontSize: "clamp(40px, 7vw, 80px)",
                            lineHeight: "1.05",
                            textTransform: "none",
                            wordBreak: "break-word",
                        }}
                    >
                       About Us
                    </h2>

                    <p className="fade_bottom">
                         Quality Homes And Builders delivers reliable, high-quality
                        residential construction with a focus on smart design,
                        durable materials, and timely execution. From concept to
                        completion, we build homes that reflect trust,
                        craftsmanship, and modern living.
                    </p>

                    <div className="about-btn">
                        <Link
                            onClick={ClickHandler}
                            to="/about"
                            className="theme-btn"
                            style={{
                                backgroundColor: "#FACD2B",
                                borderColor: "#FACD2B",
                                color: "#000",
                            }}
                        >
                            <span className="rolling-text">
                                Discover More
                            </span>
                        </Link>
                    </div>
                </div>

                <div className="image fade_bottom">
                    <img
                        src="https://res.cloudinary.com/dexvxngzg/image/upload/v1765255332/2.ce8b099b5b193f2465bc_ie5go5.jpg"
                        alt=""
                    />
                </div>

            </div>
        </section>
    )
}

export default About3;
